/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Тип оповещения */
export interface EventType {
  /** @format int64 */
  id?: number;
  code?: string;
  name?: string;
}

export interface Link {
  href?: string;
  templated?: boolean;
}

/** The message */
export interface NotifyMessageDto {
  /** @format uuid */
  uid?: string;
  /** Тип оповещения */
  eventType?: EventType;
  /** Тема или заголовок */
  title?: string;
  /** Текст оповещения */
  message?: string;
  /**
   * Кому (null -> broadcast)
   * @format uuid
   */
  toUserId?: string;
  /** Статусы сообщений */
  markType?: "NEW" | "READ" | "DELETE";
  /**
   * Дата создания оповещения
   * @format date-time
   */
  createDate?: string;
  /**
   * Дата обновления оповещения
   * @format date-time
   */
  updateDate?: string;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "http://11.0.0.33:8080",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Service Desk Notify
 * @version 1.0.0
 * @baseUrl http://11.0.0.33:8080
 * @contact Konus-group <info@konus.group> (https://www.konus.group)
 *
 * Service desk Notify System
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * @description Домашняя заглушка сервиса
   *
   * @tags Base API
   * @name Welcome
   * @summary Домашняя заглушка сервиса
   * @request GET:/
   * @secure
   */
  welcome = (params: RequestParams = {}) =>
    this.request<
      | "100 CONTINUE"
      | "101 SWITCHING_PROTOCOLS"
      | "102 PROCESSING"
      | "103 EARLY_HINTS"
      | "103 CHECKPOINT"
      | "200 OK"
      | "201 CREATED"
      | "202 ACCEPTED"
      | "203 NON_AUTHORITATIVE_INFORMATION"
      | "204 NO_CONTENT"
      | "205 RESET_CONTENT"
      | "206 PARTIAL_CONTENT"
      | "207 MULTI_STATUS"
      | "208 ALREADY_REPORTED"
      | "226 IM_USED"
      | "300 MULTIPLE_CHOICES"
      | "301 MOVED_PERMANENTLY"
      | "302 FOUND"
      | "302 MOVED_TEMPORARILY"
      | "303 SEE_OTHER"
      | "304 NOT_MODIFIED"
      | "305 USE_PROXY"
      | "307 TEMPORARY_REDIRECT"
      | "308 PERMANENT_REDIRECT"
      | "400 BAD_REQUEST"
      | "401 UNAUTHORIZED"
      | "402 PAYMENT_REQUIRED"
      | "403 FORBIDDEN"
      | "404 NOT_FOUND"
      | "405 METHOD_NOT_ALLOWED"
      | "406 NOT_ACCEPTABLE"
      | "407 PROXY_AUTHENTICATION_REQUIRED"
      | "408 REQUEST_TIMEOUT"
      | "409 CONFLICT"
      | "410 GONE"
      | "411 LENGTH_REQUIRED"
      | "412 PRECONDITION_FAILED"
      | "413 PAYLOAD_TOO_LARGE"
      | "413 REQUEST_ENTITY_TOO_LARGE"
      | "414 URI_TOO_LONG"
      | "414 REQUEST_URI_TOO_LONG"
      | "415 UNSUPPORTED_MEDIA_TYPE"
      | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
      | "417 EXPECTATION_FAILED"
      | "418 I_AM_A_TEAPOT"
      | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
      | "420 METHOD_FAILURE"
      | "421 DESTINATION_LOCKED"
      | "422 UNPROCESSABLE_ENTITY"
      | "423 LOCKED"
      | "424 FAILED_DEPENDENCY"
      | "425 TOO_EARLY"
      | "426 UPGRADE_REQUIRED"
      | "428 PRECONDITION_REQUIRED"
      | "429 TOO_MANY_REQUESTS"
      | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
      | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
      | "500 INTERNAL_SERVER_ERROR"
      | "501 NOT_IMPLEMENTED"
      | "502 BAD_GATEWAY"
      | "503 SERVICE_UNAVAILABLE"
      | "504 GATEWAY_TIMEOUT"
      | "505 HTTP_VERSION_NOT_SUPPORTED"
      | "506 VARIANT_ALSO_NEGOTIATES"
      | "507 INSUFFICIENT_STORAGE"
      | "508 LOOP_DETECTED"
      | "509 BANDWIDTH_LIMIT_EXCEEDED"
      | "510 NOT_EXTENDED"
      | "511 NETWORK_AUTHENTICATION_REQUIRED",
      any
    >({
      path: `/`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  notifications = {
    /**
     * @description Получить коллекцию оповещений указанного пользователя
     *
     * @tags Notifies
     * @name GetAllForUser
     * @summary Получить оповещения пользователя
     * @request GET:/notifications
     * @secure
     */
    getAllForUser: (
      query: {
        /**
         * UID пользователя
         * @format uuid
         */
        uid: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<NotifyMessageDto[], any>({
        path: `/notifications`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * @description Залить новое сообщение в сервис
     *
     * @tags Notifies
     * @name AddNewOneMessage
     * @summary Создать оповещение
     * @request POST:/notifications
     * @secure
     */
    addNewOneMessage: (data: NotifyMessageDto, params: RequestParams = {}) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        any
      >({
        path: `/notifications`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Обновить статус уведомлений пользователя
     *
     * @tags Notifies
     * @name UpdateStatus
     * @summary Обновить статусы
     * @request PATCH:/notifications
     * @secure
     */
    updateStatus: (
      query: {
        /**
         * Массив идентификаторов уведомлений пользователя
         * @uniqueItems true
         */
        uid: string[];
        /** Статусы сообщений */
        mark_type: "NEW" | "READ" | "DELETE";
      },
      params: RequestParams = {},
    ) =>
      this.request<
        | "100 CONTINUE"
        | "101 SWITCHING_PROTOCOLS"
        | "102 PROCESSING"
        | "103 EARLY_HINTS"
        | "103 CHECKPOINT"
        | "200 OK"
        | "201 CREATED"
        | "202 ACCEPTED"
        | "203 NON_AUTHORITATIVE_INFORMATION"
        | "204 NO_CONTENT"
        | "205 RESET_CONTENT"
        | "206 PARTIAL_CONTENT"
        | "207 MULTI_STATUS"
        | "208 ALREADY_REPORTED"
        | "226 IM_USED"
        | "300 MULTIPLE_CHOICES"
        | "301 MOVED_PERMANENTLY"
        | "302 FOUND"
        | "302 MOVED_TEMPORARILY"
        | "303 SEE_OTHER"
        | "304 NOT_MODIFIED"
        | "305 USE_PROXY"
        | "307 TEMPORARY_REDIRECT"
        | "308 PERMANENT_REDIRECT"
        | "400 BAD_REQUEST"
        | "401 UNAUTHORIZED"
        | "402 PAYMENT_REQUIRED"
        | "403 FORBIDDEN"
        | "404 NOT_FOUND"
        | "405 METHOD_NOT_ALLOWED"
        | "406 NOT_ACCEPTABLE"
        | "407 PROXY_AUTHENTICATION_REQUIRED"
        | "408 REQUEST_TIMEOUT"
        | "409 CONFLICT"
        | "410 GONE"
        | "411 LENGTH_REQUIRED"
        | "412 PRECONDITION_FAILED"
        | "413 PAYLOAD_TOO_LARGE"
        | "413 REQUEST_ENTITY_TOO_LARGE"
        | "414 URI_TOO_LONG"
        | "414 REQUEST_URI_TOO_LONG"
        | "415 UNSUPPORTED_MEDIA_TYPE"
        | "416 REQUESTED_RANGE_NOT_SATISFIABLE"
        | "417 EXPECTATION_FAILED"
        | "418 I_AM_A_TEAPOT"
        | "419 INSUFFICIENT_SPACE_ON_RESOURCE"
        | "420 METHOD_FAILURE"
        | "421 DESTINATION_LOCKED"
        | "422 UNPROCESSABLE_ENTITY"
        | "423 LOCKED"
        | "424 FAILED_DEPENDENCY"
        | "425 TOO_EARLY"
        | "426 UPGRADE_REQUIRED"
        | "428 PRECONDITION_REQUIRED"
        | "429 TOO_MANY_REQUESTS"
        | "431 REQUEST_HEADER_FIELDS_TOO_LARGE"
        | "451 UNAVAILABLE_FOR_LEGAL_REASONS"
        | "500 INTERNAL_SERVER_ERROR"
        | "501 NOT_IMPLEMENTED"
        | "502 BAD_GATEWAY"
        | "503 SERVICE_UNAVAILABLE"
        | "504 GATEWAY_TIMEOUT"
        | "505 HTTP_VERSION_NOT_SUPPORTED"
        | "506 VARIANT_ALSO_NEGOTIATES"
        | "507 INSUFFICIENT_STORAGE"
        | "508 LOOP_DETECTED"
        | "509 BANDWIDTH_LIMIT_EXCEEDED"
        | "510 NOT_EXTENDED"
        | "511 NETWORK_AUTHENTICATION_REQUIRED",
        any
      >({
        path: `/notifications`,
        method: "PATCH",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  actuator = {
    /**
     * No description
     *
     * @tags Actuator
     * @name Links
     * @summary Actuator root web endpoint
     * @request GET:/actuator
     * @secure
     */
    links: (params: RequestParams = {}) =>
      this.request<Record<string, Record<string, Link>>, any>({
        path: `/actuator`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Actuator
     * @name Health
     * @summary Actuator web endpoint 'health'
     * @request GET:/actuator/health
     * @secure
     */
    health: (params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/actuator/health`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Actuator
     * @name HealthPath
     * @summary Actuator web endpoint 'health-path'
     * @request GET:/actuator/health/**
     * @secure
     */
    healthPath: (params: RequestParams = {}) =>
      this.request<object, any>({
        path: `/actuator/health/**`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
